import { render, staticRenderFns } from "./OnBehalfDetail.vue?vue&type=template&id=4329f439&"
import script from "./OnBehalfDetail.vue?vue&type=script&lang=js&"
export * from "./OnBehalfDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports